import { NavBar } from '@in-life/components/NavBar';
import { inLifePaths } from '@in-life/paths';
import { useNavigate } from 'react-router-dom';

import { DialogID, useDialog } from '@components/Dialog';
import { IN_LIFE_ENERGY_TARIFF } from '@constants/formNames';
import { Topics } from '@features/EnergyTariffForm/EnergyFAQ/types';
import { EnergyTariffFormBase } from '@features/EnergyTariffForm/EnergyTariffFormBase';
import { BundleBasketFragment } from '@generated/gql/graphql';

import { useInLifeEnergyTracking } from './useInLifeEnergyTracking';

/**
 * In-life journey energy tariff form.
 */
const EnergyTariffForm = () => {
  const navigate = useNavigate();
  const exitDialog = useDialog(DialogID.IN_LIFE_EXIT);
  const {
    trackEnergyAddedToBasket,
    trackEvLinkClicked,
    trackEvBannerDisplayed,
    trackSmartMeterBannerDisplayed,
    trackFaqLinkClicked,
    trackFaqHeaderDisplayed,
  } = useInLifeEnergyTracking();

  const handleSubmitSuccess = (basket: Nullable<BundleBasketFragment>) => {
    navigate(inLifePaths.orderConfirm);
    trackEnergyAddedToBasket(basket);
  };

  return (
    <EnergyTariffFormBase
      persistKey={IN_LIFE_ENERGY_TARIFF}
      enableFormSync={false}
      evBanner={{
        onBannerDisplayed: trackEvBannerDisplayed,
        onLinkClick: trackEvLinkClicked,
      }}
      smartMeterBanner={{
        onBannerDisplayed: trackSmartMeterBannerDisplayed,
      }}
      faq={{
        onFaqLinkClicked: trackFaqLinkClicked,
        onFaqHeaderDisplayed: trackFaqHeaderDisplayed,
        excludeTopics: [Topics.currentSupplierExitFees],
      }}
      onSubmitSuccess={handleSubmitSuccess}
      onEditDetails={() => navigate(inLifePaths.energyDetails)}
      renderNavBar={({ onSave, isSubmitting }) => (
        <NavBar
          continueDisabled={isSubmitting}
          onContinue={onSave}
          onBack={() => exitDialog.setOpen(true)}
        />
      )}
    />
  );
};

export { EnergyTariffForm };
